var map = {
	"./1001-关于新冠的误解.md": 3609,
	"./1002-2021元旦祝福.md": 5895,
	"./1003-无职转生评价.md": 7400,
	"./1004-进击的巨人完结感想.md": 844,
	"./1005-命运石之门观后感.md": 4316,
	"./1006-2022元旦感悟.md": 3068,
	"./1007-86不存在的战区动画点评.md": 5409,
	"./1008-人类早期接触网页开发的日记.md": 3085,
	"./1009-青猪12卷关于未来剧情预测.md": 2597,
	"./1010-2023元旦感悟.md": 5622,
	"./1011-铃芽之旅影评.md": 7416,
	"./1012-大学申请.md": 6185,
	"./1013-2024元旦感悟.md": 7336,
	"./1014-uoft排课系统心得.md": 3858,
	"./1016-关于python的super函数.md": 9959,
	"./1017-如何搭建VPN.md": 5101,
	"./1018-晚安酸欠少女さユり.md": 3422,
	"./1019-个人网站项目心得.md": 4926,
	"./1020-2025元旦感悟.md": 6721,
	"./1021-青猪完结评价.md": 192,
	"./1022-2026元旦感悟.md": 2714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3278;